<style scoped lang="less">
  .header {
    width: 100%;
    background: #ffffff;
    tr {
      th {
        position: relative;
        &:first-child {
          width: 120px;
        }
        .time {
          font-size: 0;
          border-bottom: 1px solid #505050;

          &:last-child {
          }

          i {
            display: inline-block;
            border-left: 1px solid #505050;
            height: 20px;
            width: 8.3333%;
            vertical-align: bottom;

            &:first-child {
              height: 40px;
            }
            &:nth-child(7n) {
              height: 30px;
            }
          }
        }

        span {
          position: absolute;
          left: 5px;
          top: 8px;
          line-height: 1;
          font-size: 12px;
        }

      }
    }
  }
</style>
<template>
  <thead class="header">
  <tr>
    <template v-for="item in columns">
      <th v-if="item.hour">
        <span>{{item.hour}}:00</span>
        <div class="time">
          <i v-for="i in 12"/>
        </div>
      </th>
      <th v-else>{{item.title}}</th>
    </template>
  </tr>
  </thead>
</template>
<script>
  export default {
    name: 'TimetableHeader',
    props: {
      hour: {
        type: [Number, String],
      },
      columns: {
        type: Array,
      },
    },
    data () {
      return {}
    },
    methods: {},
    mounted: function () {
    },
    watch: {},
  }
</script>





// WEBPACK FOOTER //
// TimetableHeader.vue?28175152